<template>
  <label
    class="group inline-flex items-center gap-2 text-sm sm:text-base cursor-pointer p-1"
  >
    <input
      :id="id"
      :name="name"
      :value="modelValue"
      type="checkbox"
      :required="required"
      :checked="modelValue"
      @input="
        (e) =>
          $emit(
            'update:modelValue',
            Boolean((e.target as HTMLInputElement).checked),
          )
      "
      class="h-4 w-4 rounded border-transparent bg-neutral-300 dark:bg-neutral-600 outline outline-transparent focus:outline-nami-comi-blue transition-[outline-color,box-shadow] text-nami-comi-blue cursor-pointer"
    />
    <span
      class="transition-colors group-hover:text-neutral-700 dark:group-hover:text-neutral-300 select-none"
    >
      {{ label }}
    </span>
  </label>
</template>

<script setup lang="ts">
interface Props {
  modelValue?: boolean;
  id?: string;
  label?: string;
  name?: string;
  required?: boolean;
}

defineProps<Props>();

defineEmits<{
  (e: "update:modelValue", v: boolean): void;
}>();
</script>

<style scoped>
input[type="checkbox"] {
  box-shadow: none !important;
}
</style>
